import { Injectable } from '@angular/core';
import { PermissionService } from '../modules/buildings-shared/services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {

    constructor(private permissionService: PermissionService) { }

    public start(): Promise<boolean> {
        return new Promise( (resolve, reject) => {
            // PermissionService.setClientDeviceInfo(this.deviceDetectorService.getDeviceInfo(), 
            // this.deviceDetectorService.isDesktop(), this.deviceDetectorService.isTablet(), this.deviceDetectorService.isMobile());
            console.log("AppInitializerService.start() - Application started!");
            resolve (true);
        });
        
    }

/*****************************************************************
    public start(): Promise<boolean | void> {
        console.log("RUNTIME ENVIRONMENT: " + environment.env);
        return new Promise<boolean>( (resolve, reject) => {
            this.permissionService.retrievePermissions().then(result => {
                if (result) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        }).then( result => {
            console.log("Permissions retrieved? " + result);
        }).catch( (err) => {
            console.log("An error occurred retrieving permissions...");
            console.log(err.message);
        });
    }
******************************************************************/
}
